var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrio(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99993 1V15M13.0621 4.5L0.937744 11.5M0.937744 4.5L13.0621 11.5M12.6646 9.1875C12.1088 9.49576 11.6473 9.94944 11.3296 10.4999C11.0119 11.0504 10.85 11.677 10.8612 12.3125M8.80368 2.5C8.25931 2.82811 7.63554 3.00102 6.99993 3C6.36433 3.00102 5.74056 2.82811 5.19618 2.5H8.80368ZM5.19618 13.5C5.74096 13.1728 6.36446 13 6.99993 13C7.6354 13 8.25891 13.1728 8.80368 13.5H5.19618ZM12.6646 6.8125C12.1088 6.50424 11.6473 6.05056 11.3296 5.50006C11.0119 4.94956 10.85 4.32299 10.8612 3.6875L12.6646 6.8125ZM1.33524 9.1875C1.89108 9.49576 2.35257 9.94944 2.67027 10.4999C2.98796 11.0504 3.14988 11.677 3.13868 12.3125L1.33524 9.1875ZM1.33524 6.8125C1.89108 6.50424 2.35257 6.05056 2.67027 5.50006C2.98796 4.94956 3.14988 4.32299 3.13868 3.6875L1.33524 6.8125Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrio);
export default __webpack_public_path__ + "static/media/frio.22b5de647a5e5a38fd3dbfc58b31f61d.svg";
export { ForwardRef as ReactComponent };